import { createRouter, createWebHistory } from 'vue-router';

import CursosDashboard from '../views/cursos/index.vue';
import store from '../store';
import { handleDynamicImportChunkError } from '@/utils/chunkLoadError';

// Vue.use(VueRouter);
// import { createApp } from 'vue';
// const app = createApp();
// app.use(createRouter);

const routes = [
    // Dashboard de cursos (listagem pública)
    {
        path: '/',
        name: 'dashboard-cursos',
        component: CursosDashboard,
        meta: { layout: 'app' }
    },

    // Meus cursos (privado - requer login)
    {
        path: '/cursos',
        name: 'cursos',
        component: () => import(/* webpackChunkName: "meus-cursos" */ '../views/cursos/meus-cursos.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    // Entrada por link de compartilhamento (público, auth opcional)
    {
        path: '/cursos/entrar/:token',
        name: 'curso-entrar-link',
        component: () => import(/* webpackChunkName: "curso-entrar-link" */ '../views/cursos/entrar-link.vue'),
        meta: { layout: 'app' }
    },

    // Compat: landings antigas geravam /cursos/{uuid}; rota canónica é /curso/:id
    {
        path: '/cursos/:id',
        redirect: to => ({ path: `/curso/${to.params.id}` }),
    },

    // Detalhes do curso (público)
    {
        path: '/curso/:id',
        name: 'curso-detalhes',
        component: () => import(/* webpackChunkName: "curso-detalhes" */ '../views/cursos/detalhes.vue'),
        meta: { layout: 'app' }
    },

    // Finalizar matrícula (página dedicada; requer login)
    {
        path: '/curso/:id/matricular',
        name: 'curso-matricular',
        component: () => import(/* webpackChunkName: "curso-matricular" */ '../views/cursos/matricular.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/curso/:cursoId/aula/:aulaId',
        name: 'curso-aula',
        component: () => import(/* webpackChunkName: "curso-aula" */ '../views/cursos/aula.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    //auth
    {
        path: '/auth/confirmar-email',
        name: 'confirm-email-boxed',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/confirm_email_boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/completar-cadastro',
        name: 'complet-register',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/completar_cadastro.vue'),
        meta: { layout: 'auth', requiresAuth: true },
    },
    {
        path: '/bem-vindo',
        name: 'bem-vindo',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/bem_vindo_page.vue'),
        meta: { layout: 'auth', requiresAuth: true },
    },
    {
        path: '/auth/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/sso-login',
        name: 'sso-login',
        component: () => import('../views/auth/sso-login.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth-register" */ '../views/auth/register.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/auth/recuperar-senha',
        name: 'recuperar-senha',
        component: () => import(/* webpackChunkName: "auth-recuperar-senha" */ '../views/auth/recuperar_senha.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/auth/redefinir-senha',
        name: 'redefinir-senha',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-change" */ '../views/auth/recuperar_senha_alterar.vue'),
        meta: { layout: 'auth' },
    },

    {
        // Path curto exigido pela Eduzz (limite de tra_returnurl ~100 chars).
        path: '/r/:kind/:purchaseId',
        name: 'pagamento-retorno-curto',
        component: () => import(/* webpackChunkName: "pagamento-retorno" */ '../views/pagamento/retorno.vue'),
        meta: { layout: 'app' },
    },
    {
        path: '/pagamento/retorno/:kind/:purchaseId',
        name: 'pagamento-retorno-detalhe',
        component: () => import(/* webpackChunkName: "pagamento-retorno" */ '../views/pagamento/retorno.vue'),
        meta: { layout: 'app' },
    },
    {
        path: '/pagamento/retorno',
        name: 'pagamento-retorno',
        component: () => import(/* webpackChunkName: "pagamento-retorno" */ '../views/pagamento/retorno.vue'),
        meta: { layout: 'app' },
    },

    {
        path: '/termos-de-servico',
        name: 'termos-de-servico',
        component: () => import(/* webpackChunkName: "termos-de-servico" */ '../views/termos_de_servico.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/politica-de-privacidade',
        name: 'politica-de-privacidade',
        component: () => import(/* webpackChunkName: "politica-de-privacidade" */ '../views/politica_privacidade.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/aceite-legal',
        name: 'aceite-legal',
        component: () => import(/* webpackChunkName: "aceite-legal" */ '../views/legal/aceite_legal.vue'),
        meta: { layout: 'auth', requiresAuth: true },
    },

    //users
    {
        path: '/meus-dados',
        name: 'profile',
        component: () => import(/* webpackChunkName: "users-profile" */ '../views/users/profile.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/user/cadastro',
        name: 'cadastro-user',
        component: () => import(/* webpackChunkName: "cadastro-user" */ '../views/users/cadastro.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    //planos
    {
        path: '/plano',
        name: 'plano',
        component: () => import(/* webpackChunkName: "plano" */ '../views/planos/index.vue'),
    },

    //checkout
    {
        path: '/checkout/:id',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "checkout" */ '../views/faturas/preview.vue'),
    },

    //faturas
    {
        path: '/faturas',
        name: 'faturas',
        component: () => import(/* webpackChunkName: "list" */ '../views/faturas/list.vue'),
    },
    {
        path: '/auth/google/callback',
        name: 'google-callback',
        component: () => import(/* webpackChunkName: "auth-google-callback" */ '../views/auth/google-callback.vue'),
        meta: { layout: 'auth' },
    },
];

const router = createRouter({
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (typeof window === "undefined") return false;

        // Se há uma posição salva (navegação com botão voltar/avançar), use ela
        if (savedPosition) {
            return savedPosition;
        }
        
        // Para recarregamento de página ou navegação direta, não force scroll
        // Deixa o navegador manter a posição natural
        return false;
    },
});

const PUBLIC_LEGAL_DOCUMENT_ROUTES = new Set(['termos-de-servico', 'politica-de-privacidade']);

function isPublicLegalDocumentRoute(to) {
    const path = (to.path || '').replace(/\/$/, '') || '/';
    return (
        path === '/termos-de-servico' ||
        path === '/politica-de-privacidade' ||
        PUBLIC_LEGAL_DOCUMENT_ROUTES.has(to.name)
    );
}

router.beforeEach(async (to, from, next) => {
    if (isPublicLegalDocumentRoute(to)) {
        store.commit('setLoading', false);
    } else {
        store.commit('setLoading', true);
    }

    if (!requiresAuth(to)) {
        // Não chama checkAuth nas telas de autenticação: evita GET /user concorrente ao POST de login
        const isAuthScreen =
            to.name === 'login' ||
            to.name === 'register' ||
            to.name === 'recuperar-senha' ||
            to.name === 'redefinir-senha' ||
            to.name === 'pagamento-retorno' ||
            to.name === 'pagamento-retorno-detalhe' ||
            to.name === 'google-callback' ||
            to.name === 'sso-login' ||
            to.name === 'confirm-email-boxed' ||
            to.name === 'termos-de-servico' ||
            to.name === 'politica-de-privacidade';

        try {
            const alreadyAuthenticated = store.getters['auth/isAuthenticated'];
            if (!isAuthScreen && !alreadyAuthenticated) {
                await store.dispatch('auth/checkAuth', { __debugSource: 'router' });
            }
        } catch (_e) {
            // Rota pública: usuário não logado é esperado
        }

        setLayout(to);
        return next();
    }

    try {
        const hasBearer = typeof localStorage !== 'undefined' && !!localStorage.getItem('auth_token');
        const alreadyAuthenticated = store.getters['auth/isAuthenticated'];
        // Sempre revalida na API se não há token no cliente (evita “logado” só por cookie após logout)
        if (!alreadyAuthenticated || !hasBearer) {
            await store.dispatch('auth/checkAuth', { __debugSource: 'router' });
        }
        const isAuthenticated = store.getters['auth/isAuthenticated'];

        if (!isAuthenticated) {
            console.log('Not authenticated, redirecting to login');
            return redirectToLogin(to, next);
        }

        if (needsConfirmeEmail(to)) {
            console.log('Needs email confirmation, redirecting');
            return redirectToConfirmeEmail(to, next);
        }

        const legalRedirect = mustRedirectLegalAccept(to, store.state.auth.user);
        if (legalRedirect) {
            return next(legalRedirect);
        }

        setAuthenticatedLayout(to);
        return next();
    } catch (error) {
        console.error('Authentication check failed', error);
        return handleAuthError(to, next);
    }
});

// Garante que a página já tenha carregado antes de remover a tela de loading
router.beforeResolve((to, from, next) => {
    store.commit('setLoading', false);
    next();
});

router.afterEach(() => {
    store.commit('setLoading', false);
});

// Tratamento global de erros (chunk/CSS 404 após deploy → recarrega uma vez)
router.onError((error) => {
    if (handleDynamicImportChunkError(error)) {
        store.commit('setLoading', false);
        return;
    }
    console.error('Erro de navegação:', error);
    store.commit('setLoading', false);
});

function requiresAuth(to) {
    return to.matched.some(record => record.meta.requiresAuth);
}

function setLayout(to) {
    const layout = to.meta?.layout || 'app';
    store.commit('setLayout', layout === 'auth' ? 'auth' : 'app');
}

function redirectToLogin(to, next) {
    setLayout(to);
    next({ name: 'login', query: { redirect: to.fullPath } });
}

function needsConfirmeEmail(to) {
    return !store.getters['auth/isConfirmatedEmail'] && to.name !== 'confirm-email-boxed';
}

function redirectToConfirmeEmail(to, next) {
    next({ name: 'confirm-email-boxed', params: { redirect: to.fullPath } });
}

function setAuthenticatedLayout(to) {
    setLayout(to);
}

function handleAuthError(to, next) {
    setLayout(to);
    next({ name: 'login', query: { redirect: to.fullPath } });
}

function mustRedirectLegalAccept(to, user) {
    if (!user || typeof user !== 'object') {
        return null;
    }
    const legal = user.legal;
    if (!legal?.consents_active || !legal?.blocking_enforced) {
        return null;
    }
    const allowed = new Set(['aceite-legal', 'termos-de-servico', 'politica-de-privacidade']);
    if (allowed.has(to.name)) {
        return null;
    }
    return { name: 'aceite-legal', query: { redirect: to.fullPath } };
}

export default router;